import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useTranslation } from '@/hooks/use-translation';
import { cn } from '@/lib/utils';
const LANGUAGES = [{
  code: 'fr',
  name: 'Français'
}, {
  code: 'en',
  name: 'English'
}] as const;

/**
 * The language switch of the sidebar footer: two ISO codes in one segment.
 *
 * The codes are not translated — `FR` reads as French in every language.
 */
export const LanguageSegmentedControl = t0 => {
  const $ = _c(13);
  const {
    className
  } = t0;
  const {
    changeLanguage,
    currentLanguage,
    t
  } = useTranslation();
  let t1;
  if ($[0] !== changeLanguage) {
    t1 = code => () => changeLanguage(code);
    $[0] = changeLanguage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const select = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("Language", {
      ns: "navigation"
    });
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className) {
    t3 = cn("inline-flex overflow-hidden rounded-md border border-input", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== currentLanguage || $[7] !== select) {
    t4 = LANGUAGES.map(language => {
      const isSelected = currentLanguage.startsWith(language.code);
      return <button key={language.code} type="button" aria-label={language.name} aria-pressed={isSelected} onClick={select(language.code)} className={cn("cursor-pointer px-[9px] py-1.5 font-mono text-[11px] transition-colors", isSelected ? "bg-primary text-primary-foreground" : "bg-transparent text-muted-foreground hover:bg-accent")}>{language.code.toUpperCase()}</button>;
    });
    $[6] = currentLanguage;
    $[7] = select;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div role="group" aria-label={t2} className={t3}>{t4}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};